import { useField } from "formik";
import { FaCheck } from "react-icons/fa";
import P from "../../typography/P";

export const FormCheckbox = ({ label, name, onChange = () => {} }) => {
    const [field, meta, helpers] = useField({ name, type: "checkbox" });

    const isChecked = field.value;

    return (
        <div className="flex items-start gap-2">
            <label className="flex items-center gap-1 cursor-pointer select-none">
                <input
                    type="checkbox"
                    {...field}
                    checked={isChecked}
                    onChange={() => {
                        helpers.setValue(!isChecked);
                        onChange();
                    }}
                    className="hidden"
                />
                {isChecked && (
                    <P className="text-blue-100 border border-blue-50 rounded p-0.2">
                        <FaCheck />
                    </P>
                )}
                <div
                    className={`w-2 h-2 border border-blue-50 rounded ${
                        isChecked ? "hidden" : "bg-white"
                    }`}
                ></div>

                <span className="text-sm text-gray-800">{label}</span>
            </label>

            {meta.touched && meta.error && (
                <p className="text-red-500 text-xs mt-1">{meta.error}</p>
            )}
        </div>
    );
};
